import { PaletteColor } from '@mui/material'

declare module '@mui/material/styles' {
	interface Palette {
		gameBattleShips: Palette['primary']
	}

	interface PaletteOptions {
		gameBattleShips?: PaletteOptions['primary']
	}
}

declare module '@mui/material/Alert' {
	interface AlertPropsColorOverrides {
		gameBattleShips: true
	}
}

export const gameBattleShipsColor = {
	main: '#FFAA7E',
	light: '#FFE9C9',
} as PaletteColor
